import React from 'react';
import { Activity } from '@fashionnovateam/nova-ui-toolkit';
import { type ReorderWorksheetActivity } from '../../../../../Lib/Api/types/reorder-chat';

type CloseChatActivityProps = {
  activity: ReorderWorksheetActivity;
  isLast: boolean;
};

export function CloseChatActivity({
  activity,
  isLast,
}: CloseChatActivityProps) {
  const { author, created_at: createdAt } = activity;

  const isInternal = author.type === 'internal';
  const displayName = isInternal ? 'Fashion Nova' : author.name;

  return (
    <Activity
      name={displayName}
      icon="ai/ai-01"
      hideBar={isLast}
      className="w-full !max-w-full"
    >
      <Activity.Event
        name={displayName}
        date={createdAt}
        className="w-full"
        tooltipZIndex={100}
      >
        <span className="text-base-secondary">
          {' '}
          marked this negotiation as{' '}
        </span>
        <span className="font-semibold nu-text-base-primary">Resolved.</span>
      </Activity.Event>
    </Activity>
  );
}
